import type { TestCaseTItem } from "../../core";
import { tCasesPredicateFind } from "../predicateFind";

export type TCasesAssertIdUniqArg = {
  root: TestCaseTItem;
  id: TestCaseTItem["id"];
};
/**
 * should be used to check whether a given id is unique\
 * **IMPORTANT** for "empty string" id which is a very \
 * special case we will always return false as it's an \
 * implmentation detail for root node and cannot be used\
 * anywhere else
 */
export const tCasesAssertIdUniq = (arg: TCasesAssertIdUniqArg): boolean => {
  const { id, root } = arg;

  if (id === "") return false;

  return tCasesPredicateFind({ rootTreeItem: root, predicate: (it) => it.id === id }) === null;
};
